<template>
  <g>
    <g clip-path="url(#clip0_15_958)">
      <path
        d="M6.99998 7.56017C6.99998 6.62017 5.85998 6.14017 5.18998 6.81017L0.70998 11.2902C0.31998 11.6802 0.31998 12.3102 0.70998 12.7002L5.18998 17.1802C5.85998 17.8602 6.99998 17.3802 6.99998 16.4402C6.99998 16.1602 6.88998 15.8902 6.68998 15.6902L2.99998 12.0002L6.68998 8.31017C6.88998 8.11017 6.99998 7.84017 6.99998 7.56017ZM13 9.00017V7.41017C13 6.52017 11.92 6.07017 11.29 6.70017L6.69998 11.2902C6.30998 11.6802 6.30998 12.3102 6.69998 12.7002L11.29 17.2902C11.92 17.9202 13 17.4702 13 16.5802V14.9002C18 14.9002 21.5 16.5002 24 20.0002C23 15.0002 20 10.0002 13 9.00017Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_958">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
